import api, { apiErrorHandler } from "api";
import { Dispatch } from "redux";
import { AuthConstants } from "constants/constants";
import { AuthFormState, AuthPasswordReset, AuthUserEditData } from "types/Auth";
import { RootState } from "reducers/rootReducer";
import { customToast } from "hooks/toast";
import { localUserService } from "utils/localStorage";

export const handleChangeAuthModalState = () => (dispatch: Dispatch) => {
  dispatch({ type: AuthConstants.AUTH_MODAL_STATE });
};

export const giveAccessToOldShifts = () => (dispatch: Dispatch) => {
  dispatch({ type: AuthConstants.GIVE_ACCESS_TO_OLD_SHIFTS });
}

export const checkAuthFromStorage = () => (dispatch: Dispatch) => {
  const token = localUserService.getAccess();
  if (token) {
    dispatch({
      type: AuthConstants.AUTH_LOGIN_SUCCESS,
      payload: token,
    });
  }
};

export const authResetPasswordRequest = (password: string, token: string | null, redirect: () => void) => (dispatch: Dispatch) => {
  dispatch({ type: AuthConstants.AUTH_PASSWORD_RESET_PENDING });
  api
    .resetPassword({
      password,
      token,
    })
    .then((res: any) => {
        dispatch({ type: AuthConstants.PASSWORD_RESET_SUCCESS });
        customToast("success", "Password has been changed!");
        redirect()
      })
    .catch(
      apiErrorHandler((err) => {
        dispatch({ type: AuthConstants.AUTH_PASSWORD_RESET_END });
        const val:any = Object.values(err.response?.data)[0];
        const errorMessage = typeof val === 'string' ? val : val?.[0];
        customToast("error", errorMessage.replace("Not found.", "Session expired"));
      }),
    );
};

export const authLoginRequest = (data: AuthFormState) => (dispatch: Dispatch) => {
  dispatch({ type: AuthConstants.AUTH_LOGIN_PENDING });
  api
    .login(data)
    .then((res) => {
      const { access, refresh } = res.data;
      if (access && refresh) {
        localUserService.setAccess(access);
        localUserService.setRefresh(refresh);
        customToast("success", "Welcome!");
        dispatch({
          type: AuthConstants.AUTH_LOGIN_SUCCESS,
          payload: res.data,
        });
      } else {
        localUserService.logout();
      }
    })
    .catch(
      apiErrorHandler(() => {
        dispatch({ type: AuthConstants.AUTH_LOGIN_ERROR });
      }),
    );
};

export const handleChangeModalContainer = () => (dispatch: Dispatch) => {
  dispatch({
    type: AuthConstants.MODAL_CONTAINER,
  });
};

export const passwordReset = (data: AuthPasswordReset) => (dispatch: Dispatch) => {
  dispatch({ type: AuthConstants.PASSWORD_RESET_PENDING });
  api
    .passwordReset(data)
    .then(() => {
      customToast("success", "Link with password has been sent!");
      dispatch({
        type: AuthConstants.PASSWORD_RESET_SUCCESS,
      });
    })
    .catch(
      apiErrorHandler(() => {
        dispatch({ type: AuthConstants.PASSWORD_RESET_ERROR });
      }),
    );
};

export const UserDataRequestEdit =
  (updatedUser: AuthUserEditData) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { userData } = getStore()?.auth;
    if (userData?.id) {
      dispatch({ type: AuthConstants.USER_DATA_LOADING });
      api
        .updateUser(userData?.id, updatedUser)
        .then((res) => {
          if (res.data) {
            customToast("success", "Profile information was changed!");
            dispatch({
              type: AuthConstants.USER_DATA_SUCCESS,
              payload: res.data,
            });
          }
        })
        .catch(
          apiErrorHandler(() => {
            dispatch({ type: AuthConstants.USER_DATA_ERROR });
          }),
        );
    }
  };
